<template>
    <div class="city">
        <Bar title="切换城市" @goBack="goBack" />
        <div v-if="currentCity" class="current">
            <div>当前城市</div>
            <h4>{{currentCity.name}}</h4>
        </div>
        <div class="city-wrap">
            <h4>定位城市</h4>
            <div class="local-city">
                <div class="btn" @click="handleSelectCity">
                    <img v-if="localCity.code" src="@/assets/vipCoach/v2/icon_dwcs.png">
                    <span>{{localCity.name || '点击获取当前城市'}}</span>
                </div>
                <a v-if="localCity.code" @click="getAppCity">重新获取</a>
            </div>
            <h4>其他城市</h4>
            <div class="item" v-for="(item, index) in items" :key="index" @click="handleToggleCity(item)">{{item.name}}</div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant'
import { bindAppFn } from '../utils'
import Bar from './components/bar.vue'
export default {
    name: 'vipCoachCity',
    components: {
        Bar
    },
    data () {
        return {
            items: [],
            currentCity: null,
            localCity: {}
        }
    },
    methods: {
        // 查询地址
        getCityItems () {
            const loading = Toast.loading({ duration: 0, forbidClick: true })
            return this.$api.getCoachSaleTargets().then(res => {
                loading.clear()
                if (res.status) {
                    this.items = res.result
                } else {
                    Toast.fail({ message: res.message })
                }
            })
        },
        // 切换城市
        handleToggleCity (item) {
            Toast.loading({ duration: 0, forbidClick: true, message: '切换城市中...' })
            localStorage.setItem('vipCoachCity', JSON.stringify(item))
            bindAppFn({
                name: 'app',
                data: {
                    method: 'changeAppCity',
                    params: item
                }
            })
            this.currentCity = item
            this.$router.push({
                name: 'vipCoachCoach',
                query: {
                    ...item
                }
            })
        },
        goBack () {
            this.$router.back()
        },
        async handleSelectCity () {
            // 是否有本地存储信息 有的话就使用 没有的话 就获取
            if (this.localCity.code) {
                this.handleToggleCity(this.localCity)
            } else {
                this.getAppCity()
            }
        },
        getAppCity () {
            Toast.loading({ message: '获取定位中', duration: 0, forbidClick: true })
            bindAppFn({
                name: 'app',
                data: {
                    method: 'getCity'
                },
                currentFnName: 'getCoachAppCity',
                callback: async (e) => {
                    Toast.clear()
                    let city = {}
                    try {
                        city = JSON.parse(e)
                        if (city.name) {
                            Toast({ message: `当前城市定位到${city.name}` })
                        }
                    } catch (error) {
                        // 解析失败 表示没有开启定位 是否开启地区权限
                        await this.openSetting()
                    }
                    if (city.code) {
                        // 设置本地定位
                        localStorage.setItem('vipCoachCurrentCity', e)
                        this.localCity = city
                    }
                }
            })
        },
        openSetting () {
            Dialog.confirm({
                title: '温馨提示',
                message: '您还未打开定位权限，开启后可获取更多商品',
                theme: 'round-button',
                className: 'vip-coach-btn',
                confirmButtonText: '开启',
                cancelButtonText: '暂不开启'
            }).then(() => {
                bindAppFn({
                    name: 'app',
                    data: {
                        method: 'openAppSettings'
                    }
                })
            })
        },
        // 获取当前城市定位
        getCurrentCity () {
            Toast.loading({ duration: 0, forbidClick: true })
            this.$api.getCoachUserInfoCity().then(res => {
                if (res.status && res.result) {
                    const {cityName, cityCode} = res.result
                    this.currentCity = {
                        name: cityName,
                        code: cityCode
                    }
                } else {
                    // 没登录 或 没有拿到城市 就缓存中获取出来
                    const vipCoachCity = localStorage.getItem('vipCoachCity')
                    if (vipCoachCity) {
                        this.currentCity = JSON.parse(vipCoachCity)
                    }
                }
            }).finally(() => {
                Toast.clear()
            })
        }
    },
    async mounted () {
        const vipCoachCurrentCity = localStorage.getItem('vipCoachCurrentCity')
        if (vipCoachCurrentCity) {
           this.localCity = JSON.parse(vipCoachCurrentCity)
        }
        await this.getCityItems()
        this.getCurrentCity()
    },
    deactivated () {
        // 离开页面将tabbar展示出来
        bindAppFn({
            name: 'app',
            data: {
                method: 'showTabbar'
            }
        })
    }
}
</script>
<style lang="scss" scoped>
* {
    box-sizing: border-box;
}
.city{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 10px 15px 44px;
    line-height: 1;
    background: #F3F4FB;
    color:#333;
    font-size: 14px;
    .current{
        margin-bottom: 10px;
        padding:18px 15px;
        color:#fff;
        background: url('~@/assets/vipCoach/v2/bg_dqcs.png') no-repeat top left;
        background-size: 100% 100%;
        h4{
            margin-top: 10px;
            font-size: 20px;
        }
    }
    &-wrap{
        flex: 1;
        padding: 15px;
        background-color: #fff;
        border-radius: 5px;
        h4{
            margin-bottom: 15px;
            color:#999;
            font-size: 14px;
            font-weight: 400;
        }
        .item{
            padding: 17px 0;
            font-size: 15px;
            border-top: 1px solid #EBECF4;
            background: url('~@/assets/vipCoach/v2/icon_xyy.png') no-repeat center right;
            background-size: 12px 12px;
        }
    }
    .local-city{
        margin-bottom: 17px;
        display: flex;
        align-items: center;
        .btn{
            margin-right: 10px;
            display: flex;
            align-items: center;
            height: 35px;
            line-height: 35px;
            padding:0 20px;
            color:#00ca84;
            font-size: 15px;
            border: 1px solid #ebecf4;
            border-radius: 4px;
            img {
                margin-right: 5px;
                width: 12px;
                height: 12px;
                vertical-align: top;
            }
            span{
                color:#333;
            }
        }
        a{
            color:#00ca84;
            font-size: 15px;
        }
    }
}
</style>
